export const HOST = import.meta.env.VITE_HOST
export const WS_HOST = import.meta.env.VITE_WS_HOST
export const WSS = import.meta.env.VITE_WSS


const retryFetchData = async (fetchFn, callback, onError, retries = 3, delay = 1000, errStatusOnly = false) => {
  const token = localStorage.getItem('token') || "";
  
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  }

  for (let i = 0; i < retries; i++) {
      try {
          const response = await fetchFn(headers);
          if (response.status >= 400 && response.status < 500) {
              if (errStatusOnly) {
                onError(`${response.status}`);
              } else {
                const errorData = await response.json();
                console.log(errorData)
                onError(`${errorData.detail}`);
              }
              return;
          }

          if (!response.ok) {
              throw new Error(response.status);
          }
          const data = await response.json();
          console.log(data)
          
          callback(data);
          return;
      } catch (error) {
          if (i === retries - 1) {
              onError(error.message);
          }
          await new Promise(resolve => setTimeout(resolve, delay));
      }
  }
};

export const fetchBalance = async (callback, onError) => {
  const fetchData = (headers) => {
    return fetch(`${HOST}/wallet/balance`, {
      method: 'GET',
      credentials: 'include',
      headers: headers
    });
  }

  const cb = (data) => {
    setBalanceStorage(data.balance);
    callback(data.balance);
  }
  retryFetchData(fetchData, cb, onError)
};

export const getActiveGame = async (callback, onError) => {

  const fetchData = (headers) => {
    return fetch(`${HOST}/active_game`, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
  }

  const cb = (data) => {
    if (data.game_id) {
      callback(data.game_id);
    }
  }
  retryFetchData(fetchData, cb, onError)
};

export const setBalanceStorage = (balance) => {
  localStorage.setItem("balance", balance || 0.0);
}

export const login = async (userId, initData, onResponse, onError) => {
  console.log("initData", initData);

  const fetchLogin = async (headers) => {
    return fetch(`${HOST}/login`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        user_id: userId,
        init_data: initData,
      }),
      credentials: "include",
    });
  };
  retryFetchData(fetchLogin, onResponse, onError, 3, 1000, true)
}

export const newGame = async (bet, publicGame, callback, onError) => {
  const fetchNewGame = async (headers) => {
    return fetch(`${HOST}/game`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            bet: bet,
            public_game: publicGame,
            players_limit: 2,
        }),
        credentials: "include",
    });
  }
  const cb = async (data) => {
    callback(data.game_id);
  };
  retryFetchData(fetchNewGame, cb, onError);
}

export const checkAddressExists = async (callback, onError) => {
  const fetchAddress = async (headers) => {
    return fetch(`${HOST}/wallet_address`, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
  };
  const cb = async (data) => {
    callback(data.exists);
  };
  retryFetchData(fetchAddress, cb, onError)
};

export const saveWallet = async (address, appName, callback, onError) => {
  const saveData = async (headers) => {
    return fetch(`${HOST}/wallet_address`, {
      method: "POST",
      credentials: "include",
      headers: headers,
      body: JSON.stringify({ adr: address, app_name: appName }),
    });
  };

  const cb = async (data) => {
    callback(true);
  };
  retryFetchData(saveData, cb, onError)
};

export const makeWalletOp = async (method, amount, callback, onError) => {
  const walletOperation = async (headers) => {
    return fetch(`${HOST}/wallet/${method}`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ amount: amount }),
      headers: headers,
    });
  };

  const cb = async (data) => {
    callback(data.new_balance);
  };
  retryFetchData(walletOperation, cb, onError)
};

export const deleteWalletAddress = async (callback, onError) => {
  const deleteAddress = async (headers) => {
    return fetch(`${HOST}/wallet_address`, {
      method: "DELETE",
      credentials: "include",
      headers: headers,
    });
  };

  const cb = async (data) => {
    callback(data.message || "The wallet address has been successfully deleted");
  };
  retryFetchData(deleteAddress, cb, onError)
};

export const joinGame = async (gameId, callback, onError) => {

  const joinGameRequest = async (headers) => {
    return fetch(`${HOST}/join`, {
      method: "POST",
      headers: headers,
      credentials: "include",
      body: JSON.stringify({
        game_id: gameId,
      }),
    });
  };

  const cb = async (data) => {
    callback();
  };
  retryFetchData(joinGameRequest, cb, onError)
};

export const getGameInfo = async (gameId, archived, callback, onError) => {
  const fetchGameInfo = async (headers) => {
    return fetch(`${HOST}/${archived ? "archived_game" : "game"}/${gameId}`, {
      method: "GET",
      headers: headers,
      credentials: "include",
    });
  };
  const cb = async (data) => {
    callback(data);
  };
  retryFetchData(fetchGameInfo, cb, onError, 3, 1000, true)
};


export const redicrectAuth = () => {
  const token = localStorage.getItem('token');
  const tokenTimestamp = localStorage.getItem('tokenTimestamp');

    if (!token || !tokenTimestamp) {
        return true; // Токена или временной метки нет
    }

    const expirationTime = parseInt(tokenTimestamp, 10)    
    if (Date.now() > expirationTime) {
      localStorage.clear();
      return true
    }
    return false
}


export const getPublicGames = async (callback, onError) => {
  const fetchPublicGames = async (headers) => {
    return fetch(`${HOST}/public_games`, {
      method: "GET",
      headers: headers,
      credentials: "include",
    });
  };
  const cb = async (data) => {
    callback(data.public_games);
  };
  retryFetchData(fetchPublicGames, cb, onError, 3, 1000, true)
};
